var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuLowStock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.89396 12.0938C9.43372 12.0938 9.06063 11.7207 9.06063 11.2605L9.06063 8.32626C9.06063 7.86602 9.43372 7.49293 9.89396 7.49293C10.3542 7.49293 10.7273 7.86602 10.7273 8.32626L10.7273 11.2605C10.7273 11.7207 10.3542 12.0938 9.89396 12.0938Z",
    fill: "#21272F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0415 4.07993C9.97903 3.9612 9.80903 3.96121 9.74654 4.07993L3.50817 15.9328C3.44975 16.0438 3.53024 16.1771 3.65565 16.1771H16.1324C16.2578 16.1771 16.3383 16.0438 16.2799 15.9328L10.0415 4.07993ZM8.27168 3.30368C8.95902 1.99773 10.829 1.99773 11.5164 3.30368L17.7548 15.1566C18.3973 16.3774 17.512 17.8438 16.1324 17.8438H3.65565C2.27605 17.8438 1.39076 16.3774 2.03331 15.1566L8.27168 3.30368Z",
    fill: "#21272F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.06063 13.8525C9.06063 13.3923 9.43372 13.0192 9.89396 13.0192H9.90133C10.3616 13.0192 10.7347 13.3923 10.7347 13.8525C10.7347 14.3128 10.3616 14.6859 9.90133 14.6859H9.89396C9.43372 14.6859 9.06063 14.3128 9.06063 13.8525Z",
    fill: "#21272F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuLowStock);
export default __webpack_public_path__ + "static/media/menuLowStock.feb3aa53689d4e7fadcdb92485f7faa7.svg";
export { ForwardRef as ReactComponent };